import { render, staticRenderFns } from "./TeamBlazonLoader.vue?vue&type=template&id=1f2683e6&"
import script from "./TeamBlazonLoader.vue?vue&type=script&lang=js&"
export * from "./TeamBlazonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports